import { Component } from '@angular/core';
import { LIFERAY_WEB_CONSTANT } from '../../../utils/liferay.constant';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent {
  contentId = LIFERAY_WEB_CONSTANT.privacyPolicy.id;
}
